import { useEffect, useImperativeHandle, useRef, useState, forwardRef } from "react";
import { RotateCcw } from "lucide-react";

// Podpis prstem / myší – vrací PNG data URL přes ref.toDataURL(); ref.isEmpty()
export const SignaturePad = forwardRef(function SignaturePad({ height = 160, testid = "signature-pad" }, ref) {
    const canvasRef = useRef(null);
    const drawing = useRef(false);
    const [empty, setEmpty] = useState(true);

    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        const dpr = window.devicePixelRatio || 1;
        const rect = c.getBoundingClientRect();
        c.width = rect.width * dpr;
        c.height = rect.height * dpr;
        const ctx = c.getContext("2d");
        ctx.scale(dpr, dpr);
        ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0F172A"; ctx.lineWidth = 2.5;
    }, []);

    const pos = (e) => {
        const r = canvasRef.current.getBoundingClientRect();
        const t = e.touches?.[0] || e;
        return { x: t.clientX - r.left, y: t.clientY - r.top };
    };
    const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.beginPath(); ctx.moveTo(x, y); };
    const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.lineTo(x, y); ctx.stroke(); setEmpty(false); };
    const stop = () => { drawing.current = false; };
    const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); };

    useImperativeHandle(ref, () => ({ toDataURL: () => canvasRef.current.toDataURL("image/png"), isEmpty: () => empty, clear }));

    return (
        <div className="space-y-1">
            <div className="relative border-2 border-dashed border-slate-300 bg-white" style={{ height }}>
                <canvas ref={canvasRef} className="w-full h-full touch-none" data-testid={testid}
                        onMouseDown={start} onMouseMove={move} onMouseUp={stop} onMouseLeave={stop} onTouchStart={start} onTouchMove={move} onTouchEnd={stop} />
                {empty && <div className="absolute inset-0 flex items-center justify-center text-xs text-slate-400 pointer-events-none">Podepište se zde</div>}
            </div>
            <button type="button" onClick={clear} className="text-[11px] text-slate-500 hover:text-slate-900 inline-flex items-center gap-1" data-testid={`${testid}-clear`}><RotateCcw className="w-3 h-3" /> Smazat podpis</button>
        </div>
    );
});
